import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "elemental-resonance" }
const _hoisted_2 = ["onUpdate:modelValue", "onChange"]
const _hoisted_3 = ["onChange"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "option-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.displayName('元素共鳴')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementalResonanceList, (item) => {
      return (_openBlock(), _createElementBlock("label", {
        key: item.key
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": ($event: any) => ((_ctx.elementalResonanceChecked[item.key]) = $event),
          onChange: ($event: any) => (_ctx.onChange(item.key))
        }, null, 40, _hoisted_2), [
          [_vModelCheckbox, _ctx.elementalResonanceChecked[item.key]]
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.displayName(item.名前)), 1),
        (item.key == '草元素共鳴')
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dendroOption) = $event)),
              onChange: ($event: any) => (_ctx.onChange(item.key))
            }, _cache[13] || (_cache[13] = [
              _createElementVNode("option", { value: "0" }, null, -1),
              _createElementVNode("option", { value: "20" }, "+20", -1),
              _createElementVNode("option", { value: "30" }, "+30", -1),
              _createElementVNode("option", { value: "50" }, "+50", -1)
            ]), 40, _hoisted_3)), [
              [_vModelSelect, _ctx.dendroOption]
            ])
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.descriptionList, (item, index) => {
      return (_openBlock(), _createElementBlock("article", {
        key: index,
        class: _normalizeClass(_ctx.elementClass(item[0]))
      }, _toDisplayString(item[1]), 3))
    }), 128)),
    _cache[20] || (_cache[20] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("p", null, _toDisplayString(_ctx.displayName('月兆')), 1),
    _createElementVNode("label", null, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.workMoonsign.nascentGleam) = $event)),
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeMoonsign(1)))
      }, null, 544), [
        [_vModelCheckbox, _ctx.workMoonsign.nascentGleam]
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.displayName('初照')), 1)
    ]),
    _createElementVNode("label", null, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.workMoonsign.ascendantGleam) = $event)),
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeMoonsign(2)))
      }, null, 544), [
        [_vModelCheckbox, _ctx.workMoonsign.ascendantGleam]
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.displayName('満照')), 1)
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("label", null, [
      _cache[14] || (_cache[14] = _createTextVNode(_toDisplayString('月兆キャラクター以外') + " ")),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.workMoonsign.otherCharacter) = $event)),
        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeMoonsign(2))),
        disabled: !_ctx.workMoonsign.ascendantGleam
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moonsignOtherCharacterList, (character) => {
          return (_openBlock(), _createElementBlock("option", {
            key: character,
            value: character
          }, _toDisplayString(character), 9, _hoisted_5))
        }), 128))
      ], 40, _hoisted_4), [
        [_vModelSelect, _ctx.workMoonsign.otherCharacter]
      ])
    ]),
    _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("label", null, [
      _cache[15] || (_cache[15] = _createTextVNode(_toDisplayString('月兆キャラクター以外による月反応ダメージ +') + " ")),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.workMoonsign.lunarDmgBonus) = $event)),
        min: "0",
        max: "36",
        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeMoonsign(2))),
        disabled: !_ctx.workMoonsign.ascendantGleam || (_ctx.workMoonsign.otherCharacter !== null && _ctx.workMoonsign.otherCharacter.length > 0)
      }, null, 40, _hoisted_6), [
        [_vModelText, _ctx.workMoonsign.lunarDmgBonus]
      ])
    ]),
    _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
    (_ctx.workMoonsign.ascendantGleam)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[16] || (_cache[16] = [
          _createStaticVNode(" 月反応ダメージ最大36%アップ<br data-v-4990f2e0><span class=\"pyro\" data-v-4990f2e0>炎元素</span>、<span class=\"electro\" data-v-4990f2e0>雷元素</span>、<span class=\"cryo\" data-v-4990f2e0>氷元素</span>:攻撃力4000まで<br data-v-4990f2e0><span class=\"hydro\" data-v-4990f2e0>水元素</span>:HP上限60000まで<br data-v-4990f2e0><span class=\"geo\" data-v-4990f2e0>岩元素</span>:防御力3600まで<br data-v-4990f2e0><span class=\"anemo\" data-v-4990f2e0>風元素</span>、<span class=\"dendro\" data-v-4990f2e0>草元素</span>:元素熟知1600まで ", 19)
        ])))
      : _createCommentVNode("", true),
    _cache[24] || (_cache[24] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("p", null, _toDisplayString(_ctx.displayName('魔導')), 1),
    _createElementVNode("label", null, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.workHexerei.hexerei) = $event)),
        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onChangeHexerei()))
      }, null, 544), [
        [_vModelCheckbox, _ctx.workHexerei.hexerei]
      ]),
      _cache[17] || (_cache[17] = _createElementVNode("span", null, "魔導秘儀", -1))
    ]),
    _cache[25] || (_cache[25] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("p", null, _toDisplayString(_ctx.displayName('極星フィールド')), 1),
    _createElementVNode("label", null, [
      _cache[19] || (_cache[19] = _createElementVNode("span", null, "極星フィールド", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.workPolestar.polestar) = $event)),
        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChangePolestar()))
      }, _cache[18] || (_cache[18] = [
        _createStaticVNode("<option value=\"-1\" data-v-4990f2e0></option><option value=\"0\" data-v-4990f2e0>0層</option><option value=\"1\" data-v-4990f2e0>1層</option><option value=\"2\" data-v-4990f2e0>2層</option><option value=\"3\" data-v-4990f2e0>3層</option><option value=\"4\" data-v-4990f2e0>4層</option><option value=\"5\" data-v-4990f2e0>5層</option><option value=\"6\" data-v-4990f2e0>6層</option><option value=\"7\" data-v-4990f2e0>7層</option><option value=\"8\" data-v-4990f2e0>8層</option><option value=\"9\" data-v-4990f2e0>9層</option><option value=\"10\" data-v-4990f2e0>10層</option><option value=\"11\" data-v-4990f2e0>11層</option><option value=\"12\" data-v-4990f2e0>12層</option>", 14)
      ]), 544), [
        [_vModelSelect, _ctx.workPolestar.polestar]
      ])
    ]),
    _cache[26] || (_cache[26] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("ul", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayStatAjustmentList, (item) => {
        return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
      }), 128))
    ])
  ]))
}